import PropTypes from "prop-types";
import React from "react";

import AccessMembershipExperienceCardDesign from "./AccessMembershipExperienceCardDesign";
import LatestCashbackCardDesign from "./LatestCashbackCardDesign";
import TopDiscountCardDesign from "./TopDiscountCardDesign";
import TopGiftCardDesign from "./TopGiftCardDesign";

import { useAuth } from "../../../hoc/AuthContext";

import useWindowSize from "../../../hooks/useWindowSize";

import { backgroundColor, textColor } from "../../../Utils/CommonFunctions";


export default function WhatsNewCardDesign({ item }) {
  const isMobile = useWindowSize();
  const { integratorTheme } = useAuth();

  const offerTypeToComponent = {
    "affiliate_cashback": LatestCashbackCardDesign,
    "merchant_funded_offers": TopDiscountCardDesign,
    "access_n_membership": AccessMembershipExperienceCardDesign,
    "gift_card": TopGiftCardDesign,
    "experience": AccessMembershipExperienceCardDesign,
  };

  const OfferWhatsNewCard = () => {
    const Component = offerTypeToComponent[item?.offer_type];
    if (!Component) return null;

    return (
      <Component
        isMobile={isMobile}
        whatsDesign={true}
        item={item}
        image={item?.brand?.logo ? item?.brand?.logo : item.bg_image}
      />
    );
  };

  return (
    <>
      <div
        className={`${isMobile ? "whatsnewMobileCard" : "w-[300px] h-[240px]"} rounded-[20px] drop-shadow-md relative z-0 bg-no-repeat bg-center bg-cover`}
        style={{
          backgroundImage: `url('${item.bg_image ? item?.bg_image : item?.brand?.bg_image}')`,
          // backgroundColor: `#${item?.brand?.hex_code}`,
          backgroundColor: `#f7f7f7`,
        }}
      ></div>

      <div className={`absolute z-10 ${isMobile ? "whatsnewMobileBottomCard" : "-bottom-[60px] left-[50px]"}`}>
        <OfferWhatsNewCard />
      </div>

      {item?.saving_amount && (
        <div style={{ backgroundColor: backgroundColor(integratorTheme), color: textColor(integratorTheme) }} className="absolute z-10 top-6 -left-1 w-auto font-semibold py-1 px-2 rounded-tl-[4px] rounded-bl-[4px] font-Inter-Tight whatsNewRibbon">
          {item?.saving_amount}
        </div>
      )}
    </>
  );
};
WhatsNewCardDesign.propTypes = {
  item: PropTypes.shape({
    offer_type: PropTypes.string,
    brand: PropTypes.shape({
      logo: PropTypes.string,
      bg_image: PropTypes.string,
      hex_code: PropTypes.string,
    }),
    bg_image: PropTypes.string,
    saving_amount: PropTypes.string,
  }).isRequired,
};
